<div class="d-flex">
  <div class="header-btn-lg pr-0">
    <div class="widget-content p-0">
      <div class="widget-content-wrapper">
        <div class="widget-content-left ml-6">
          <div class="btn-group" ngbDropdown placement="bottom-right">
            <button type="button" class="btn btn-link p-0 mr-2" ngbDropdownToggle>
              <div class="widget-content-wrapper header-user-info" >
                <div class="circle  widget-content-left ">
                  <p class="circle-inner">{{ user?.userName | slice:0:1 | uppercase }}</p>
                </div>
                <div class="widget-heading" style="font-size: larger;font-family: 'Roboto';color: #333;font-size: medium;"> {{
                  user?.userName }}</div>

              </div>
            </button>
            <div class="dropdown-menu-lg" ngbDropdownMenu style="font-size: medium;">
              <div class="dropdown-menu-header">
                <div class="dropdown-menu-header-inner bg-info">
                  <div class="menu-header-image opacity-2 dd-header-bg-6"></div>
                  <div class="menu-header-content text-left">
                    <div class="widget-content p-0">
                      <div class="widget-content-wrapper">
                        <div class="widget-content-left mr-3">
                          <!-- <img
                            width="42"
                            src="./assets/images/avatars/1.jpg"
                            alt=""
                            class="rounded-circle"
                          /> -->
                        </div>
                        <div class="widget-content-left">
                          <div class="widget-heading">{{ user?.userName }}</div>
                          <div class="widget-subheading opacity-8">
                            {{ user?.userType }}
                          </div>
                        </div>
                        <div class="widget-content-right mr-2">
                          <button (click)="logout()" class="btn-pill btn-shadow btn-shine btn btn-focus" style="color: #fff;background-color: #3f668a;border-color: #dfdcea;">
                            Logout
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="scroll-area-xs">
                <perfect-scrollbar [autoPropagation]="true">
                  <ul class="nav flex-column">
                    <li class="nav-item-header nav-item">Activity</li>
                    <!-- <li class="nav-item"><a [routerLink]="" class="nav-link">Chat
                        <div class="ml-auto badge badge-pill badge-info">8</div>
                      </a></li> -->
                    <li class="nav-item">
                      <a (click)="changePassword()" class="nav-link">Change Password</a>
                    </li>
                    <!-- <li class="nav-item-header nav-item">My Account</li> -->
                    <!-- <li class="nav-item"><a [routerLink]="" class="nav-link">Settings
                        <div class="ml-auto badge badge-success">New</div>
                      </a></li> -->
                    <!-- <li class="nav-item"><a [routerLink]="" class="nav-link">Messages
                        <div class="ml-auto badge badge-warning">512</div>
                      </a></li> -->
                    <!-- <li class="nav-item"><a [routerLink]="" class="nav-link">Logs</a></li> -->
                  </ul>
                </perfect-scrollbar>
              </div>
              <!-- <ul class="nav flex-column">
                <li class="nav-item-divider mb-0 nav-item"></li>
              </ul> -->
              <!-- <div class="grid-menu grid-menu-2col overflow-hidden">
                <div class="no-gutters row">
                  <div class="col-sm-6">
                    <button class="btn-icon-vertical btn-transition btn-transition-alt pt-2 pb-2 btn btn-outline-warning">
                      <i class="pe-7s-chat icon-gradient bg-amy-crisp btn-icon-wrapper mb-2"></i>
                      Message Inbox
                    </button>
                  </div>
                  <div class="col-sm-6">
                    <button class="btn-icon-vertical btn-transition btn-transition-alt pt-2 pb-2 btn btn-outline-danger">
                      <i class="pe-7s-ticket icon-gradient bg-love-kiss btn-icon-wrapper mb-2"></i>
                      <b>Suppor Tickets</b>
                    </button>
                  </div>
                </div>
              </div> -->
              <!-- <ul class="nav flex-column">
                <li class="nav-item-divider nav-item"></li>
                <li class="nav-item-btn text-center nav-item">
                  <button class="btn-wide btn btn-primary btn-sm">Open Messages</button>
                </li>
              </ul> -->
            </div>
          </div>
        </div>

        <!-- <div class="widget-content-right header-user-info ml-3">
          <button type="button" class="btn btn-shadow p-1 btn-info btn-sm" placement="bottom"
            ngbTooltip="Tooltip Example!">
            <fa-icon [icon]="faCalendar" class="mr-1 ml-1"></fa-icon>
          </button>
        </div> -->
      </div>
    </div>
  </div>
  <!-- <div class="header-btn-lg">
    <button type="button" class="hamburger hamburger--elastic" [ngClass]="{'is-active' : globals.toggleDrawer}"
      (click)="toggleDrawer()">
      <span class="hamburger-box"><span class="hamburger-inner"></span></span>
    </button>
  </div> -->
</div>

<app-change-password #changePasswordRef></app-change-password>